import { onCLS, onINP, onLCP, type Metric } from 'web-vitals';
import posthog from 'posthog-js';

const captureMetric = (metric: Metric) => {
  const payload = {
    name: metric.name,
    value: metric.value,
    delta: metric.delta,
    id: metric.id,
    rating: (metric as { rating?: string }).rating,
  };

  if (posthog?.capture) {
    posthog.capture('web_vitals', payload);
  } else {
    // Fallback logging for environments without analytics
    // eslint-disable-next-line no-console
    console.info('[web-vitals]', payload);
  }
};

export function initWebVitals() {
  if (typeof window === 'undefined') return;
  onCLS(captureMetric);
  onINP(captureMetric);
  onLCP(captureMetric);
}
